export const FETCH_QUESTION = ' FETCH_QUESTION';
export const IS_LOADING = ' IS_LOADING';
export const ASSESSMENT_SENT_QUESTONS_SUCCESS = 'ASSESSMENT_SENT_QUESTONS_SUCCESS';
export const  ASSESSMENT_QUESTONS_STATUS      = ' ASSESSMENT_QUESTONS_STATUS';
export const   ASSESSMENT_QUESTONS_RESULT      = 'ASSESSMENT_QUESTONS_RESULT';
export const ASSESSMENT_COMPLETED = 'ASSESSMENT_COMPLETED'
